module.exports = __webpack_public_path__ + "img/mercedes-eqc-1.c1f1df5d.jpg";